import Star from '@/images/Star.svg';
import { ttsVoiceFunctionFilter } from '@/state/presenters';
import { FUNCTION } from '@d-id/tts';
import { SelectChangeEvent } from '@mui/material/Select';
import { useRecoilState } from 'recoil';
import { FilterChipMultiSelect, FilterOption } from './FilterChipMultiSelect';

const featureOptions: FilterOption[] = [
    { value: FUNCTION.SPEED, label: 'Speed' },
    { value: FUNCTION.STYLE, label: 'Style' },
];

export const FunctionChipMultiSelect = () => {
    const [ttsVoiceFunctionFilterValue, setTtsVoiceFunctionFilter] = useRecoilState(ttsVoiceFunctionFilter);

    const handleChange = (e: SelectChangeEvent<any>) => {
        setTtsVoiceFunctionFilter(e.target.value);
    };

    const values = ttsVoiceFunctionFilterValue.map(v => featureOptions.find(f => f.value === v)).filter(v => !!v) as FilterOption[];

    return (
        <>
            <FilterChipMultiSelect
                data-testid="voice-feature-filter"
                id="feature-filter"
                values={values}
                options={featureOptions}
                onChange={handleChange}
                valueToRender={{ label: 'Function', icon: Star }}
            />
        </>
    );
};
